module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.typeCode === 'CLAIM') ? _c('v-assist-claim', {
    attrs: {
      "itemId": _vm.id,
      "typeCode": _vm.typeCode
    }
  }) : _vm._e(), _vm._v(" "), (['DEED', 'BINDER', 'POST', 'CONTRACTOR_CHECK'].includes(_vm.typeCode)) ? _c('v-assist-deed', {
    attrs: {
      "itemId": _vm.id,
      "typeCode": _vm.typeCode
    }
  }) : _vm._e(), _vm._v(" "), (['PACKAGE'].includes(_vm.typeCode)) ? _c('v-assist-package', {
    attrs: {
      "itemId": _vm.id,
      "typeCode": _vm.typeCode
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3be88354","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/assist/AssistPage.vue
// module id = 1169
// module chunks = 1